import { Autocomplete, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomAutocomplete } from '@components/Styles/CommonStyle';
import React from 'react';

const ControlledAutocompleteBox = ({ name, options, isRequired = false, label = '', placeholder = '' }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? '필수 선택 항목입니다.' : undefined,
      }}
      render={({ field, fieldState }) => (
        <CustomAutocomplete
          disableClearable
          options={options}
          getOptionLabel={(option) => option.label || ''}
          isOptionEqualToValue={(option, value) => option.value === value}
          onChange={(_, data) => field.onChange(data?.value || '')}
          value={options.find((opt) => opt.value === field.value) || null}
          autoHighlight
          autoSelect
          autoComplete
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              required={isRequired}
            />
          )}
        />
      )}
    />
  );
};

export default ControlledAutocompleteBox;
